import { Box, Chip } from "@mui/material";
import React from "react";

import { ItemStatus } from "../../../services/orderService";

interface StatusTimelineProps {
  currentStatusId: number;
  allStatuses: ItemStatus[];
}

const StatusTimeline: React.FC<StatusTimelineProps> = ({
  currentStatusId,
  allStatuses,
}) => {
  // Sort statuses by sortOrder
  const sortedStatuses = [...allStatuses].sort(
    (a, b) => a.sortOrder - b.sortOrder,
  );

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
      {sortedStatuses.map((status) => {
        const isCurrentStatus = status.id === currentStatusId;
        const currentStatus = sortedStatuses.find(
          (s) => s.id === currentStatusId,
        );
        const isCompleted = currentStatus
          ? status.sortOrder < currentStatus.sortOrder
          : false;

        return (
          <Chip
            key={status.id}
            label={
              <span className="notranslate" translate="no">
                {status.icon} {status.displayName}
              </span>
            }
            size="small"
            className="notranslate"
            translate="no"
            sx={{
              fontSize: "0.65rem",
              height: "20px",
              backgroundColor: isCurrentStatus
                ? status.color
                : isCompleted
                  ? "#e8f5e8"
                  : "#f5f5f5",
              color: isCurrentStatus
                ? "#ffffff"
                : isCompleted
                  ? "#2e7d32"
                  : "#666666",
              border: isCurrentStatus
                ? `2px solid ${status.color}`
                : isCompleted
                  ? "1px solid #4caf50"
                  : "1px solid #e0e0e0",
              fontWeight: isCurrentStatus ? 600 : 400,
              opacity: isCompleted ? 0.7 : 1,
              "& .MuiChip-label": {
                px: 0.5,
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default StatusTimeline;
